export default {
  name: 'page-element-logo',
  props: {
    logo: {
      type: String,
      required: false,
      default: 'logo'
    }
  },
  computed: {
    path() {
      return `/dist/logos/website/${this.logo}.svg`
    }
  }
}
